export default __webpack_public_path__ + "static/media/carnations 1.8b4a8095.jpg";